import { render, staticRenderFns } from "./IpoPortfolioGroup.vue?vue&type=template&id=25c43a12"
import script from "./IpoPortfolioGroup.vue?vue&type=script&lang=js"
export * from "./IpoPortfolioGroup.vue?vue&type=script&lang=js"
import style0 from "./IpoPortfolioGroup.vue?vue&type=style&index=0&id=25c43a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports